/**
=========================================================
* Trust Cargo - spinners
=========================================================
*/

// Soft UI Dashboard React base styles
import colors from "assets/theme/base/colors";

const { primary } = colors;

/**
 * Gold spinner, thinner stroke and a slower turn than the MUI default.
 * A fast, heavy spinner makes a wait feel frantic; a slow thin one makes the
 * same wait feel deliberate.
 */
const circularProgress = {
  styleOverrides: {
    root: {
      color: primary.main,
    },

    circle: {
      strokeLinecap: "round",
    },

    circleIndeterminate: {
      animationDuration: "1.6s",
    },
  },

  defaultProps: {
    thickness: 3.2,
    size: 40,
  },
};

export default circularProgress;
